import { useEffect, useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid'

import { TableAdapter } from '@makyoapp/makyo-common'

import { TablesDropdownV2 } from '../TablesDropdownV2'

type ExtendedTableAdapter = TableAdapter & { isCurrentUser?: boolean }

export interface TableDataSourceDropdownProps {
  id?: string
  tables: TableAdapter[]
  value?: string
  onChange?: (nextValue?: string) => void
  noSelect?: boolean
  disabled?: boolean
  showCurrentUserLogin?: boolean
}

export function TableDataSourceDropdown({
  id = uuidv4(),
  tables,
  value,
  onChange,
  noSelect,
  disabled,
  showCurrentUserLogin,
}: TableDataSourceDropdownProps) {
  const defaultUserTable = tables.find((tb) => tb.isUserTable)

  const tblOptions = useMemo(() => {
    const baseOptions = noSelect ? tables : [{ id: '', name: 'Select Table' } as TableAdapter, ...tables]

    if (showCurrentUserLogin) {
      const [selectOption, ...restOptions] = baseOptions
      return [
        selectOption,
        {
          id: `${defaultUserTable?.id}__current_user`,
          name: 'Current Logged-In User',
          isCurrentUser: true,
        } as ExtendedTableAdapter,
        ...restOptions.map((option) => ({
          ...option,
          isCurrentUser: false,
        })),
      ]
    }
    return baseOptions.map((option) => ({
      ...option,
      isCurrentUser: false,
    }))
  }, [noSelect, tables, showCurrentUserLogin, defaultUserTable?.id]) as ExtendedTableAdapter[]

  useEffect(() => {
    const tbl = tblOptions.find((tb) => tb.id === value && tb.isDeleted === true)

    if (tbl?.isDeleted) {
      const filtered = tblOptions.filter((tbl) => !tbl.isDeleted)
      onChange?.(filtered[0].id)
    }
  }, [value, tblOptions, onChange])

  return <TablesDropdownV2 key={id} value={value} onChange={onChange} tables={tables} disabled={disabled} />
}
